import React from "react";
import {connect} from "react-redux";
import queryString from "query-string";
import {Modal} from "react-bootstrap";
import {productoActions} from "../../_actions";
import MenuFiltro, {FiltrosActivos} from "../includes/MenuFiltro";
import {busquedaActions} from "../../_actions/busqueda.actions";
import {actualizarMetaTags, categoriaDeLaRuta, history, LoaderGeneral, nombreVendedor, prepareDataSearch, restaurarMetaTags, textosCategoria, TIPO_ENVIO, TIPO_REPUESTO, urlCategoria} from "../../_helpers";
import {Form, Formik} from "formik";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {buscadorService} from "../../_services";
import {LoginPage} from "../general";
import { NumericFormat as NumberFormat } from "react-number-format";
import cartService from "../../_services/cart/cart.service";
import {Link} from "react-router-dom";
import Select from "react-select";
import authService from "../../_services/cart/authService";
import {faList, faTh} from "@fortawesome/free-solid-svg-icons";
import alertService from "../../_services/cart/alert.service";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import {FranjaConfianza} from "./utils/FranjaConfianza";
import CarrouselProductosRel from "./utils/CarrouselProductosRel";
import {ModalWhatsappVendedor} from "./utils/ModalWhatsappVendedor";
import {PushOptIn} from "../includes/PushOptIn";
import vendedorService from "../../_services/cart/vendedor.service";
import productoServiceTs from "../../_services/cart/producto.service";
import CarrouselImages from "./utils/CarrouselImages";
import { AlertaModal } from "./utils/AlertaModal";
import { BadgeOferta, PrecioTachado, precioVigente } from "./utils/Oferta";
import { Paginador } from "./utils/Paginador";
import tiendaService from "../../_services/cart/tienda.service";

const _ = require("lodash");

/**
 * Hasta dónde llega "mobile" para el listado.
 *
 * <p>Es el mismo breakpoint que usa MiTabla para pasar a cards: si los dos se separan queda un
 * rango de anchos donde la tabla ya es card pero el listado sigue paginado, que es justo el tamaño
 * donde el paginado se vuelve incómodo.
 */
const MOBILE_QUERY = "(max-width: 48em)";

/** Aire que queda arriba del listado al volver a el despues de filtrar. */
const MARGEN_SCROLL = 16;

/**
 * Como quedo cada listado al irse de el, por entrada del historial.
 *
 * <p>Al entrar a una publicacion el listado se desmonta, y al volver con "atras" arrancaba de cero:
 * sin los filtros que la persona habia elegido, en la pagina 1 y arriba de todo. Aca se guarda lo
 * necesario para dibujarlo igual que antes —filtros, orden, resultados ya traidos y la posicion del
 * scroll— sin volver a pedir nada.
 *
 * <p>Vive en memoria y no en sessionStorage a proposito: si se recarga la pagina lo esperable es un
 * listado fresco, no uno de hace media hora.
 */
const snapshots = new Map();
const MAX_SNAPSHOTS = 10;

/**
 * Identifica la entrada del historial. `key` la pone history en cada push; la primera entrada de la
 * sesion (la que se abrio escribiendo la URL) no la tiene, y ahi alcanza con la URL.
 */
const claveDe = (location) => location && (location.key || location.pathname + location.search);

/** `pagedSearch` se muta in situ en todo el componente: el snapshot necesita su propia copia. */
const copiarPagedSearch = (pagedSearch) => ({
    ...pagedSearch,
    orderBy: {...pagedSearch.orderBy},
});

class Listador extends React.Component {
    constructor(props) {
        super(props);

        // Se restaura aca y no en componentDidMount: render() corre antes y con una opcion del
        // buscador en redux ya dispararia una busqueda nueva (ver initSearchValues).
        const snapshot = history.action === "POP" && snapshots.get(claveDe(props.location));

        if (snapshot) {
            const esMobile = Listador.esViewportMobile();

            this.state = {
                ...this.state,
                ...snapshot.state,
                pagedSearch: copiarPagedSearch(snapshot.state.pagedSearch),
                firstSearch: false,
                loading: false,
                cargandoMas: false,
                // Si se roto el telefono mientras tanto, mismo criterio que alCambiarBreakpoint.
                esMobile,
                acumulados: esMobile === snapshot.state.esMobile
                    ? snapshot.state.acumulados
                    : esMobile ? snapshot.state.data?.results?.content || [] : [],
            };

            this.scrollARestaurar = snapshot.scrollY;
            this.primeraBusqueda = false;

            // La opcion del header que haya en redux ya esta reflejada en lo que se restaura (o es
            // de una busqueda posterior, que no es la que se esta volviendo a ver).
            if (props.option) this.optionAplicada = props.option.tipo + ":" + props.option.id;
        }

        /*
         * En una pagina de categoria manda la URL. La opcion del buscador del header que haya en
         * redux es de una busqueda anterior (la que llevo a /busqueda, antes de entrar aca) y, si
         * se aplicara, pisaria los filtros de la categoria y sacaria a la persona de la pagina.
         */
        if (props.option && categoriaDeLaRuta(props.match?.path, props.match?.params)) {
            this.optionAplicada = props.option.tipo + ":" + props.option.id;
        }
    }

    /** `true` si el viewport entra en el breakpoint mobile. Falso en SSR o sin matchMedia. */
    static esViewportMobile = () =>
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia(MOBILE_QUERY).matches;

    handleClose = () => this.setState({show: false});
    handleShow = () => this.setState({show: true});

    state = {
        // Las publicaciones con oferta de la vidriera. Arranca vacio y queda vacio si no hay
        // ninguna corriendo: el carrusel no se dibuja en ese caso.
        productosEnOferta: [],
        /*
         * La tienda que se esta mirando cuando se entra con ?vendedor=N. Solo sirve para el cartel
         * de contexto de arriba: sin el, el listado filtrado por un vendedor se ve igual que el
         * listado completo y no hay forma de saber que se esta adentro de una tienda.
         */
        tienda: undefined,
        appName: process.env.PUBLIC_URL,
        showLogin: false,
        showAlertModal: false,
        /*
         * Si el panel de filtros esta abierto. Solo cuenta en mobile: de `xl` para
         * arriba el panel es una columna fija y Bootstrap ignora este estado. Hace
         * falta tenerlo para poder cerrarlo al elegir un filtro.
         */
        filtrosAbiertos: false,
        isGridView: true,
        producto: undefined,
        productoConsulta: undefined,
        contactosPrecargados: false,
        ordenadores: [
            {
                id: "precioDesc",
                sort: "desc",
                field: "precio",
                nombre: "Precio Mayor a Menor",
            },
            {
                id: "precioAsc",
                sort: "asc",
                field: "precio",
                nombre: "Precio Menor a Mayor",
            },
            {
                id: "createdDesc",
                sort: "desc",
                field: "createdDate",
                nombre: "Mas nuevos primero",
            },
            {
                id: "createdAsc",
                sort: "asc",
                field: "createdDate",
                nombre: "Mas viejos primero",
            },
        ],
        firstSearch: true,
        loading: true,
        /*
         * En mobile el listado no se pagina: se van sumando las páginas al hacer scroll.
         *
         * `acumulados` es lo que se dibuja ahí —todas las páginas traídas desde la última búsqueda,
         * no sólo la última— y `cargandoMas` es el spinner del pie. Son estado aparte de `loading` a
         * propósito: `loading` desmonta la grilla entera para poner el loader, que es lo correcto
         * cuando cambia la búsqueda pero no cuando se está agregando la página siguiente —haría
         * desaparecer lo que la persona está mirando y la mandaría de vuelta arriba—.
         */
        esMobile: Listador.esViewportMobile(),
        acumulados: [],
        cargandoMas: false,
        values: {},
        pagedSearch: {
            pageSize: 12,
            page: 0,
            search: "",
            orderBy: {
                id: "createdDesc",
                sort: "desc",
                field: "createdDate",
                nombre: "Mas nuevos primero",
            },
        },
        data: {},
    };

    /**
     * El vendedor que viene por la URL (`/busqueda?vendedor=3`), o undefined.
     *
     * <p>Es la puerta de entrada de "ver todo el catalogo" desde una tienda: el listado ya sabia
     * filtrar por vendedor —el backend lo resuelve con la option `vendedor` y el menu de filtros
     * tiene su combo— pero no habia forma de linkear a un listado ya filtrado.
     */
    vendedorDeLaUrl = () => {
        // Dos formas de llegar al mismo listado: la URL linda de la tienda
        // (/tienda/1-nicolas-lemme/catalogo) y el filtro suelto (?vendedor=1), que es lo que
        // sigue armando el menu de filtros y lo que ya circula en links viejos.
        const {slug} = this.props.match?.params || {};

        const id = slug
            ? vendedorService.idDesdeSlug(slug)
            : queryString.parse(this.props.location?.search || "").vendedor;

        const num = Number(id);

        return Number.isFinite(num) && num > 0 ? num : undefined;
    };

    /**
     * Sale de la tienda y vuelve al catalogo completo.
     *
     * <p>No alcanza con linkear a `/busqueda`: react-router no desmonta este componente al cambiar
     * solo la query string, asi que `componentDidMount` no vuelve a correr y el filtro seguiria
     * puesto con la URL diciendo lo contrario. Se limpia el filtro, se busca de nuevo y recien ahi
     * se emprolija la URL.
     */
    salirDeTienda = () => {
        const values = {...this.state.values};
        delete values.vendedor;

        this.setState({tienda: undefined});
        this.buscarData(true, values);

        restaurarMetaTags();
        history.replace("/busqueda");
    };

    /** Trae los datos de la tienda para el cartel de contexto. Sin ?vendedor= no hace nada. */
    cargarTienda = () => {
        const vendedorId = this.vendedorDeLaUrl();

        if (!vendedorId) {
            this.setState({tienda: undefined});
            return;
        }

        vendedorService.traerDataVendedor(vendedorId, (vendedor) => {
            this.setState({tienda: vendedor});

            if (vendedor) this.actualizarSeoTienda(vendedor);
        });
    };

    /**
     * Metadatos del catalogo de una tienda.
     *
     * <p>Esta es la URL que el vendedor pega en sus redes, asi que es justamente donde no puede
     * salir el titulo generico del sitio. El prerender del backend cubre a los bots que no
     * ejecutan JS; esto cubre la pestaña y a los clientes que si lo ejecutan.
     */
    actualizarSeoTienda = (vendedor) => {
        const nombre = nombreVendedor(vendedor);
        const ubicacion = [vendedor.ciudad, vendedor.provincia?.nombre].filter(Boolean).join(", ");

        actualizarMetaTags({
            titulo: `Catálogo de ${nombre} — Repuestos usados${ubicacion ? ` en ${ubicacion}` : ""}`,
            descripcion: `${vendedor.publicaciones || "Todas las"} publicaciones de repuestos usados de ${nombre}${
                ubicacion ? ` en ${ubicacion}` : ""
            }. Comprá y consultá por DeAutopartes.`,
            imagen: vendedor.imagenes?.[0]?.url,
            url: window.location.origin + vendedorService.crearUrlCatalogo(vendedor),
        });
    };

    /* ── Paginas de categoria (/repuestos/..., /autopartes-usadas/...) ─────────────────────── */

    /** Los ids de la categoria de la URL (`{tipoRepuestoId, marcaId, modeloId}`), o undefined. */
    categoriaDeLaUrl = () => categoriaDeLaRuta(this.props.match?.path, this.props.match?.params);

    /** La categoria de la URL volcada sobre los filtros, pisando solo tipo, marca y modelo. */
    sembrarCategoria = (values, cat) => {
        const sembrados = {...values};

        delete sembrados.tipoRepuesto;
        delete sembrados.marca;
        delete sembrados.modelo;
        delete sembrados.version;

        if (cat.tipoRepuestoId) sembrados.tipoRepuesto = {id: cat.tipoRepuestoId};
        if (cat.marcaId) sembrados.marca = {id: cat.marcaId};
        if (cat.modeloId) sembrados.modelo = {id: cat.modeloId};

        return sembrados;
    };

    /** `true` si los filtros de tipo, marca y modelo son exactamente los de la categoria. */
    coincideConCategoria = (values, cat) => {
        // Number(): segun por donde entro el filtro (combo, URL, buscador del header) el id puede
        // venir como string, y "5" !== 5 mandaria a la persona a /busqueda sin haber cambiado nada.
        const n = (id) => (id ? Number(id) : undefined);

        return !!cat &&
            n(values.tipoRepuesto?.id) === cat.tipoRepuestoId &&
            n(values.marca?.id) === cat.marcaId &&
            n(values.modelo?.id) === cat.modeloId;
    };

    /**
     * Tipo, marca y modelo de unos filtros con los nombres resueltos contra los combos, o
     * undefined si todavia no llegaron los filtros o algun id no existe.
     */
    nombrarCategoria = (values) => {
        const {filtros} = this.props;
        if (!filtros) return undefined;

        const buscar = (lista, id) => (id ? (lista || []).find((it) => Number(it.id) === Number(id)) : undefined);

        const tipoRepuesto = buscar(filtros.tipoRepuestos, values.tipoRepuesto?.id);
        const marca = buscar(filtros.marcas, values.marca?.id);
        const modelo = buscar(filtros.modelos, values.modelo?.id);

        if ((values.tipoRepuesto?.id && !tipoRepuesto) || (values.marca?.id && !marca) || (values.modelo?.id && !modelo)) {
            return undefined;
        }

        return {tipoRepuesto, marca, modelo};
    };

    /**
     * La categoria que se esta mirando, con nombres, o undefined.
     *
     * <p>Solo mientras los filtros sigan siendo los de la URL: si la persona toca otro combo, el
     * cartel de categoria deja de valer (y {@link #seguirCategoria} ya cambio la URL).
     */
    categoriaActual = () => {
        const cat = this.categoriaDeLaUrl();

        if (!this.coincideConCategoria(this.state.values, cat)) return undefined;

        const nombrada = this.nombrarCategoria(this.state.values);
        const textos = nombrada && textosCategoria(nombrada);

        return textos ? {...nombrada, ...textos} : undefined;
    };

    /**
     * Metadatos de la pagina de categoria. El prerender del backend cubre a los bots; esto cubre la
     * pestaña y a los clientes que ejecutan JS. Se aplica una vez por categoria.
     */
    actualizarSeoCategoria = () => {
        const cat = this.categoriaActual();
        const clave = cat && window.location.pathname;

        if (!cat || this.seoCategoriaAplicado === clave) return;

        this.seoCategoriaAplicado = clave;

        actualizarMetaTags({
            titulo: cat.titulo,
            descripcion: cat.descripcion,
            url: window.location.origin + urlCategoria(cat),
        });
    };

    /**
     * La persona cambio los filtros estando en una pagina de categoria.
     *
     * <p>Si lo que quedo elegido es otra categoria (sumo la marca a un tipo, cambio de modelo) la
     * URL pasa a ser esa, que es la que se puede compartir y la que conoce Google. Si no hay pagina
     * para esa combinacion se vuelve a /busqueda, igual que al salir de una tienda: la URL no puede
     * seguir diciendo "Compresores Ford" con otra cosa en pantalla. `replace` y no `push`: es la
     * misma pantalla con otro filtro, no una navegacion.
     */
    seguirCategoria = (values) => {
        const cat = this.categoriaDeLaUrl();

        if (!cat || this.coincideConCategoria(values, cat)) return;

        const nombrada = this.nombrarCategoria(values);
        const destino = (nombrada && urlCategoria(nombrada)) || "/busqueda";

        this.seoCategoriaAplicado = undefined;
        restaurarMetaTags();

        if (destino !== history.location.pathname) history.replace(destino);
    };

    componentDidUpdate(prevProps) {
        const cambioRuta = prevProps.location?.pathname !== this.props.location?.pathname;

        // Se navego de una categoria a otra sin desmontar (react-router reusa el componente): hay
        // que sembrar los filtros de la nueva. Si la URL la cambio seguirCategoria, los filtros ya
        // coinciden y no se busca de nuevo.
        if (cambioRuta) {
            const cat = this.categoriaDeLaUrl();

            if (cat && !this.coincideConCategoria(this.state.values, cat)) {
                this.buscarData(true, this.sembrarCategoria(this.state.values, cat));
            }
        }

        if (cambioRuta || prevProps.filtros !== this.props.filtros) this.actualizarSeoCategoria();
    }

    componentDidMount() {
        const {option, filtros} = this.props;

        if (filtros === undefined) this.props.traerFiltros();

        this.seguirScroll();
        this.escucharBreakpoint();

        if (this.scrollARestaurar !== undefined) {
            this.alVolver();
            return;
        }

        let values = {};

        // El filtro de la URL se siembra antes de la primera busqueda: si se aplicara despues, la
        // pantalla mostraria primero el catalogo entero y despues el de la tienda.
        const vendedorId = this.vendedorDeLaUrl();
        if (vendedorId) values.vendedor = {id: vendedorId};

        const categoria = this.categoriaDeLaUrl();
        if (categoria) values = this.sembrarCategoria(values, categoria);

        if (this.state.firstSearch && option) {
            // El texto libre no viaja como id de taxonomia, va en searchValue.
            if (option.tipo !== "TEXTO" && !categoria) {
                values.tipoId = {
                    id: option.id,
                };

                values.tipoValue = {
                    id: option.tipo,
                };
            }

            this.setState({firstSearch: false});
        }

        /*
         * render() corre antes que este hook, asi que con una opcion de texto libre
         * initSearchValues ya disparo la busqueda: volver a llamar aca es pedir dos veces lo mismo.
         */
        if (!(option && option.tipo === "TEXTO")) {
            this.buscarData(true, values);
        }

        const savedView = localStorage.getItem("userViewChoice");
        if (savedView) {
            this.setState({isGridView: savedView === "grid"});
        }

        this.cargarTienda();
        this.actualizarSeoCategoria();

        /*
         * La vidriera solo se pide en la home. En /busqueda la persona vino a ver un resultado
         * concreto y un carrusel de ofertas al azar le corre los productos hacia abajo — el
         * mismo criterio que ya se usa para el cartel de notificaciones.
         */
        if (this.esHome()) {
            productoServiceTs.traerProductosEnOferta((productos) =>
                this.setState({productosEnOferta: productos || []})
            );
        }
    }

    componentWillUnmount() {
        // Solo hace falta si se habia pisado el titulo con el de una tienda, pero restaurar de mas
        // es inocuo: deja los metadatos por defecto del sitio.
        if (this.state.tienda || this.seoCategoriaAplicado) restaurarMetaTags();

        this.guardarSnapshot();
        this.dejarDeSeguirScroll();

        this.dejarDeEscucharBreakpoint();
        this.observarSentinel(null);
    }

    /* ── Volver atras al listado ─────────────────────────────────────────────────────────── */

    /**
     * Lleva la cuenta del scroll mientras el listado esta en pantalla.
     *
     * <p>No alcanza con leer `window.scrollY` al desmontar: la ficha del producto hace
     * `scrollTo(0, 0)` en su constructor, que corre antes de que este componente se desmonte, asi
     * que para ese momento el scroll ya es 0.
     */
    seguirScroll = () => {
        this.scrollY = window.scrollY;
        this.alScrollear = () => {
            this.scrollY = window.scrollY;
        };
        window.addEventListener("scroll", this.alScrollear, {passive: true});
    };

    dejarDeSeguirScroll = () => {
        window.removeEventListener("scroll", this.alScrollear);
        this.cancelarRestaurarScroll();
    };

    guardarSnapshot = () => {
        const clave = claveDe(this.props.location);

        // A mitad de una busqueda no hay nada coherente que guardar: al volver se busca de nuevo.
        if (!clave || this.state.loading) {
            snapshots.delete(clave);
            return;
        }

        const {values, pagedSearch, data, acumulados, esMobile, tienda, productosEnOferta, isGridView} = this.state;

        snapshots.delete(clave); // re-insertar lo deja ultimo en el orden del Map
        snapshots.set(clave, {
            scrollY: this.scrollY || 0,
            state: {
                values,
                pagedSearch: copiarPagedSearch(pagedSearch),
                data,
                acumulados,
                esMobile,
                tienda,
                productosEnOferta,
                isGridView,
            },
        });

        // Se descarta el mas viejo: nadie vuelve diez listados para atras.
        if (snapshots.size > MAX_SNAPSHOTS) snapshots.delete(snapshots.keys().next().value);
    };

    /** Lo que hace el montaje cuando el estado vino del snapshot: nada de buscar, solo reubicarse. */
    alVolver = () => {
        const {tienda, data} = this.state;

        if (tienda) this.actualizarSeoTienda(tienda);
        this.actualizarSeoCategoria();

        this.precargarContactos(data);
        this.restaurarScroll(this.scrollARestaurar);
        this.scrollARestaurar = undefined;
    };

    /**
     * Vuelve a la posicion en que estaba la persona.
     *
     * <p>Se reintenta durante un rato porque la pagina puede no tener todavia el alto final —las
     * imagenes de las cards y los carruseles terminan de acomodarse despues del primer render— y
     * `scrollTo` a una posicion que todavia no existe queda clavado mas arriba. Si la persona toca
     * la pantalla o la rueda mientras tanto se deja de insistir: pelearle el scroll es peor.
     */
    restaurarScroll = (y) => {
        if (!y) return;

        const limite = Date.now() + 1500;

        const intentar = () => {
            // `instant` explicito: el html tiene `scroll-behavior: smooth`, y con eso la pagina
            // se veia bajar animada desde el banner en lugar de aparecer donde estaba.
            window.scrollTo({top: y, behavior: "instant"});
            this.scrollY = y;

            if (Math.abs(window.scrollY - y) > 2 && Date.now() < limite) {
                this.rafScroll = requestAnimationFrame(intentar);
            } else {
                this.cancelarRestaurarScroll();
            }
        };

        this.cancelarRestaurarScroll = () => {
            cancelAnimationFrame(this.rafScroll);
            window.removeEventListener("wheel", this.cancelarRestaurarScroll);
            window.removeEventListener("touchstart", this.cancelarRestaurarScroll);
            this.cancelarRestaurarScroll = () => {};
        };

        window.addEventListener("wheel", this.cancelarRestaurarScroll, {passive: true});
        window.addEventListener("touchstart", this.cancelarRestaurarScroll, {passive: true});

        intentar();
    };

    cancelarRestaurarScroll = () => {};

    /* ── Scroll infinito en mobile ───────────────────────────────────────────────────────── */

    /**
     * Sigue el ancho del viewport para saber si toca paginado o scroll.
     *
     * <p>Se escucha el cambio y no se mide una sola vez al montar porque rotar el telefono cruza el
     * breakpoint sin recargar la pagina: sin esto, el listado se queda con el modo del arranque y
     * queda una grilla acumulada sin paginador, o un paginador sobre una lista que ya venia
     * acumulada.
     */
    escucharBreakpoint = () => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;

        this.mql = window.matchMedia(MOBILE_QUERY);

        this.alCambiarBreakpoint = (e) => {
            const esMobile = e.matches;

            // Al cruzar el breakpoint se arranca de nuevo desde la pagina que se esta viendo: lo
            // acumulado de mobile no tiene sentido bajo el paginador, y al reves la grilla
            // arrancaria vacia hasta el primer scroll.
            this.setState({
                esMobile,
                acumulados: esMobile ? this.state.data?.results?.content || [] : [],
            });
        };

        // Safari < 14 solo tiene addListener sobre MediaQueryList.
        if (this.mql.addEventListener) this.mql.addEventListener("change", this.alCambiarBreakpoint);
        else this.mql.addListener(this.alCambiarBreakpoint);
    };

    dejarDeEscucharBreakpoint = () => {
        if (!this.mql) return;

        if (this.mql.removeEventListener) this.mql.removeEventListener("change", this.alCambiarBreakpoint);
        else this.mql.removeListener(this.alCambiarBreakpoint);

        this.mql = undefined;
    };

    /** Quedan paginas por traer de la busqueda actual. */
    hayMasPaginas = () => {
        const page = this.state.data?.results;
        if (!page) return false;

        return page.number + 1 < page.totalPages;
    };

    /**
     * Engancha el observer al centinela del pie de la lista.
     *
     * <p>Es un ref callback y no un observer creado en `componentDidMount` porque el centinela
     * aparece y desaparece —no esta en desktop, ni cuando ya no quedan paginas—, y un observer
     * apuntando a un nodo que React desmonto no vuelve a disparar nunca mas.
     *
     * <p>El `rootMargin` es lo que hace que la pagina siguiente ya este pedida cuando la persona
     * llega al fondo: sin el, el pedido arranca recien cuando el centinela entra en pantalla y se
     * ve el hueco.
     */
    observarSentinel = (nodo) => {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = undefined;
        }

        this.sentinel = nodo;

        if (!nodo || typeof IntersectionObserver === "undefined") return;

        this.observer = new IntersectionObserver(
            (entradas) => {
                if (entradas.some((e) => e.isIntersecting)) this.cargarMas();
            },
            {rootMargin: "400px 0px"}
        );

        this.observer.observe(nodo);
    };

    /**
     * Trae la pagina siguiente y la suma a lo que ya se ve.
     *
     * <p>Los guardas son los que evitan que el observer dispare tres veces la misma pagina mientras
     * la primera todavia esta viajando.
     */
    cargarMas = () => {
        if (!this.state.esMobile) return;
        if (this.state.loading || this.state.cargandoMas) return;
        if (!this.hayMasPaginas()) return;

        let pagedSearch = this.state.pagedSearch;

        pagedSearch.page = this.state.data.results.number + 1;

        this.setState({pagedSearch: pagedSearch});

        this.realizarBusqueda(pagedSearch, this.state.values, true);
    };

    /** `/` y `/home` son la home; `/busqueda` reusa este mismo componente pero no lo es. */
    esHome = () => {
        const path = history.location.pathname;
        return path === "/" || path === "/home";
    };

    /**
     * Ultima opcion del buscador del header que ya se aplico.
     *
     * <p>Es un campo de instancia y no estado a proposito: {@link #initSearchValues} se llama desde
     * render() y setState no impacta hasta el proximo ciclo, asi que con estado la misma opcion se
     * podria aplicar dos veces antes de que la marca quede asentada.
     */
    optionAplicada = undefined;

    /**
     * Vuelca en los filtros la opcion que se eligio en el buscador del header.
     *
     * <p>La guarda es por opcion aplicada y no por comparacion contra los filtros actuales. Antes
     * comparaba contra los filtros, lo que tenia dos problemas: elegir un tipo de repuesto no
     * entraba nunca (REPUESTO faltaba en la condicion), y si la persona cambiaba un filtro a mano
     * la vieja opcion de redux seguia viva y se volvia a imponer sola en el siguiente render.
     */
    initSearchValues = (option) => {
        const clave = option.tipo + ":" + option.id;

        if (this.optionAplicada === clave) {
            return;
        }

        this.optionAplicada = clave;

        // El texto libre no es taxonomia: no toca los filtros, va por searchValue.
        if (option.tipo === "TEXTO") {
            this.buscarTexto(option.nombre);

            return;
        }

        /*
         * Copia y no el objeto de estado.
         *
         * Esto alimenta initialValues de Formik, que con enableReinitialize decide si reinicializar
         * comparando en profundidad contra el initialValues anterior. Mutando this.state.values in
         * situ, "anterior" y "nuevo" eran el mismo objeto ya modificado: siempre daban iguales,
         * Formik no reinicializaba nunca y los selects quedaban vacios aunque la busqueda saliera
         * bien — que es exactamente lo que pasaba al elegir "Fiat Cronos" en el buscador.
         */
        let inic = {...this.state.values};

        switch (option.tipo) {
            case "MARCA":
                inic.marca = {
                    id: option.id,
                };
                break;
            case "MODELO":
                inic.modelo = {
                    id: option.id,
                };

                inic.marca = {
                    id: option.marca.id,
                };
                break;
            case "VERSION":
                inic.version = {
                    id: option.id,
                };

                inic.modelo = {
                    id: option.modelo.id,
                };

                inic.marca = {
                    id: option.marca.id,
                };
                break;
            case "REPUESTO":
                inic.tipoRepuesto = {
                    id: option.id,
                };
                break;
            default:
                return;
        }

        this.buscarData(true, inic);
    };

    buscarImagenes = (prod) => {
        if (prod.imagenes && prod.imagenes.length > 0) {
            return prod.imagenes;
        } else {
            if (
                !!prod.productoBaja &&
                prod.productoBaja.imagenes &&
                prod.productoBaja.imagenes.length > 0
            ) {
                return prod.productoBaja.imagenes;
            } else {
                return [{url: this.state.appName + "/images/banner-bg.jpg", type:'image/jpeg'}];
            }
        }
    };

    toggleGridView = (e, type) => {
        e.preventDefault();
        this.setState({isGridView: type === "grid"});
        localStorage.setItem("userViewChoice", type);
    };

    crearAlerta = () => {
        //console.log('values',this.state.values);
        //Crear producto desde los filtros
        let producto = {};

        if (this.state.values.marca?.id) {
            producto.marca = {id: this.state.values.marca.id};
        }

        if (this.state.values.modelo?.id) {
            producto.modelo = {id: this.state.values.modelo.id};
        }

        if (this.state.values.version?.id) {
            producto.version = {id: this.state.values.version.id};
        }

        if (this.state.values.tipoRepuesto?.id) {
            producto.tipoRepuesto = {id: this.state.values.tipoRepuesto.id};
        }

        if (authService.isAuthenticated()) {
            this.setState({showAlertModal: true, producto: producto});
        } else {
            this.setState({showLogin: true, producto: producto});
        }
    };

    /**
     * Alerta precargada con el auto y el repuesto de una publicacion concreta.
     *
     * <p>Es la salida de las publicaciones con precio a consultar: no hay boton de compra, asi
     * que lo que se ofrece es "avisame cuando entre uno de estos" —con los combos ya elegidos—
     * ademas de escribirle al vendedor. `crearAlerta` hace lo mismo pero desde los filtros de
     * la busqueda, que es otra cosa: ahi no hay una publicacion de la que copiar.
     */
    crearAlertaDeProducto = (prod) => {
        const producto = {
            marca: prod.marca?.id ? {id: prod.marca.id} : undefined,
            modelo: prod.modelo?.id ? {id: prod.modelo.id} : undefined,
            version: prod.version?.id ? {id: prod.version.id} : undefined,
            tipoRepuesto: prod.tipoRepuesto?.id ? {id: prod.tipoRepuesto.id} : undefined,
        };

        if (authService.isAuthenticated()) {
            this.setState({showAlertModal: true, producto});
        } else {
            this.setState({showLogin: true, producto});
        }
    };

    handleClose = () => {
        this.setState({showLogin:false , showAlertModal: false});
    };

    loginSuccess = () => {
        this.setState({showLogin: false, showAlertModal: true});
    };

    setLoading = (val) => {
        this.setState({loading: val});
    };

    /**
     * Una sola request con los vendedores distintos de la pagina. Sirve para que el boton
     * "Consulta" de cada card sepa, ya al renderizarse, si abre el modal de contactos o
     * linkea derecho al WhatsApp del vendedor: decidirlo en el click implicaria un
     * window.open post-fetch, que el navegador bloquea como popup.
     */
    precargarContactos = (data) => {
        const vendedorIds = (data?.results?.content ?? [])
            .map((prod) => prod?.vendedor?.id)
            .filter((id) => !!id);

        if (vendedorIds.length === 0) {
            return;
        }

        vendedorService.precargarContactos(vendedorIds, () => {
            this.setState({contactosPrecargados: true});
        });
    };

    /**
     * Boton "Consulta" de cada card. Si el vendedor tiene otros WhatsApp cargados abre el
     * modal para elegir a quien escribirle; si no, linkea derecho a su numero como siempre.
     *
     * <p>En la card del listado va `compact`: solo el icono de WhatsApp, sin el texto "Consulta"
     * al lado — entre eso y "Comprar" y "Agregar al carrito" la botonera no entraba en mobile.
     */
    renderBotonConsulta = (prod, compact) => {
        if (productoActions.tieneContactosExtra(prod)) {
            return (
                <button
                    className="button"
                    type="button"
                    data-type="message"
                    title="Consulta por WhatsApp"
                    onClick={() => this.setState({productoConsulta: prod})}
                >
                    <div className="btn--logo">
                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                    </div>
                    {!compact && <span> Consulta</span>}
                </button>
            );
        }

        return (
            <a target="_blank" rel="noreferrer" href={productoActions.crearLinkWhatsapp(prod)}>
                <button className="button" type="button" data-type="message" title="Consulta por WhatsApp">
                    <div className="btn--logo">
                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                    </div>
                    {!compact && <span> Consulta</span>}
                </button>
            </a>
        );
    };

    /* FUNCIONES PARA SEARCH */
    setOrderBy = (newOrder) => {
        let pagedSearch = this.state.pagedSearch;

        pagedSearch.orderBy = newOrder;
        pagedSearch.orderDirection = newOrder.sort;

        // En mobile hay que volver a la primera: la lista es una sola tira acumulada, y reordenar
        // trayendo la pagina 5 de un orden nuevo deja arriba el resto de un orden que ya no existe.
        // En desktop se respeta lo de siempre, que es quedarse en la pagina que se estaba viendo.
        if (this.state.esMobile) pagedSearch.page = 0;

        this.setState({pagedSearch: pagedSearch});

        this.realizarBusqueda(pagedSearch, this.state.values);
    };

    setNewPage = (pageNumber) => {
        let pagedSearch = this.state.pagedSearch;

        pagedSearch.page = pageNumber;

        this.setState({pagedSearch: pagedSearch});

        this.realizarBusqueda(pagedSearch, this.state.values);
    };

    /** El bloque de filtros + resultados; se usa para volver ahi despues de cada busqueda. */
    listadoRef = React.createRef();

    /**
     * La busqueda del montaje todavia no se resolvio.
     *
     * <p>El salto al listado es para cuando la persona toca un filtro: se hizo algo y hay que
     * mostrar el resultado. Al entrar no se hizo nada todavia, y arrancar la pagina ya scrolleada
     * dejaba el banner y el buscador del header fuera de pantalla —en mobile y en desktop—, que es
     * justo lo primero que hay que ver al llegar.
     */
    primeraBusqueda = true;

    /**
     * Despues de filtrar, deja los resultados arriba de todo.
     *
     * <p>Antes era un `window.scrollTo(0, 0)` y cada vez que se tocaba un filtro la pagina
     * volvia al banner y a la vidriera de ofertas: habia que scrollear de nuevo hasta abajo
     * para ver lo que uno mismo acababa de filtrar. Se apunta al bloque del listado, que
     * arranca en la barra de "Ordenar por" y sigue con la grilla.
     *
     * <p>El fallback al tope es por si el nodo todavia no se monto (primera busqueda).
     */
    irAlListado = () => {
        const nodo = this.listadoRef.current;

        if (!nodo) {
            window.scrollTo({top: 0, behavior: "smooth"});
            return;
        }

        const destino = nodo.getBoundingClientRect().top + window.scrollY - MARGEN_SCROLL;

        window.scrollTo({top: Math.max(destino, 0), behavior: "smooth"});
    };

    buscarData = (nuevaBusqueda, values) => {
        this.setState({values: values}, this.actualizarSeoCategoria);
        this.seguirCategoria(values);

        let pagedSearch = this.state.pagedSearch;

        if (nuevaBusqueda) pagedSearch.page = 0;

        this.realizarBusqueda(pagedSearch, values);
    };

    /**
     * Busqueda por texto libre desde el listado.
     *
     * <p>Convive con los filtros en vez de reemplazarlos: el texto acota lo que ya esta filtrado,
     * que es lo que se espera cuando uno escribe teniendo una marca elegida.
     */
    buscarTexto = (texto) => {
        let pagedSearch = this.state.pagedSearch;

        pagedSearch.search = texto;
        pagedSearch.page = 0;

        this.setState({pagedSearch: pagedSearch});
        this.realizarBusqueda(pagedSearch, this.state.values);
    };

    limpiarTexto = () => {
        this.buscarTexto("");
    };

    /**
     * @param sumando `true` cuando es la pagina siguiente del scroll infinito: los resultados se
     *                agregan abajo, no se pisa la grilla con el loader y no se vuelve al tope.
     */
    realizarBusqueda = (query, values, sumando) => {
        if (sumando) this.setState({cargandoMas: true});
        else this.setLoading(true);

        // Se baja la bandera al salir el pedido y no al volver: si la primera busqueda falla, la
        // siguiente ya es una busqueda pedida por la persona y tiene que llevar al listado igual.
        const esLaPrimera = this.primeraBusqueda;
        if (!sumando) this.primeraBusqueda = false;

        buscadorService
            .buscar(prepareDataSearch(query, "createdDate", "DESC", values))
            .then(
                (data) => {
                    this.setState({
                        data: data,
                        loading: false,
                        cargandoMas: false,
                        acumulados: this.acumular(data, sumando),
                    });
                    this.precargarContactos(data);

                    if (sumando) this.reintentarSentinel();
                    else if (!esLaPrimera) this.irAlListado();
                },
                (error) => {
                    this.setState({cargandoMas: false});
                    this.setLoading(false);
                    alertService.error(error);
                }
            );
    };

    /**
     * Lo acumulado de mobile despues de una respuesta.
     *
     * <p>Filtra por id contra lo que ya hay: dos publicaciones pueden aparecer en dos paginas
     * distintas si alguien publico algo mientras la persona scrollea —el orden por defecto es
     * "mas nuevos primero", asi que una publicacion nueva corre a todas las demas un lugar hacia
     * abajo— y React tira por las keys repetidas.
     */
    acumular = (data, sumando) => {
        const nuevos = data?.results?.content || [];

        if (!sumando) return nuevos;

        const yaEstan = new Set(this.state.acumulados.map((p) => p.id));

        return this.state.acumulados.concat(nuevos.filter((p) => !yaEstan.has(p.id)));
    };

    /**
     * Vuelve a preguntar si el centinela sigue a la vista.
     *
     * <p>El observer avisa de los cruces, no del estado: si despues de sumar una pagina el
     * centinela quedo igual de visible —pantalla alta, pagina corta— no dispara de nuevo y la lista
     * se queda sin cargar hasta que la persona mueva el scroll a mano. Volver a observarlo fuerza
     * una lectura del estado actual; si ya no se ve, no pasa nada.
     */
    reintentarSentinel = () => {
        if (!this.observer || !this.sentinel) return;

        this.observer.unobserve(this.sentinel);
        this.observer.observe(this.sentinel);
    };

    /* FUNCIONES PARA SEARCH */

    render() {
        const {loading, data, isGridView, ordenadores, esMobile, acumulados, cargandoMas} = this.state;

        // En mobile la grilla dibuja todo lo traído desde la última búsqueda; en desktop, la página
        // que está activa en el paginador.
        const items = esMobile ? acumulados : data?.results?.content || [];

        const stateValues = this.state.values;

        const {option, filtros} = this.props;

        const categoria = this.categoriaActual();

        const customSelect = {
            control: (provided) => ({
                ...provided,
                background: "transparent",
                borderColor: "transparent",
                height: "25px",
            }),
        };

        if (option) {
            this.initSearchValues(option);
        }

        return (
            <>
                <div className="container__dap">
                    <div className="z-1 align-items-center">

                        {/* Sólo en la home, igual que el cartel de notificaciones: en /busqueda
                            y en el catálogo de una tienda la persona vino a ver un resultado, y
                            esto le correría los productos hacia abajo. */}
                        {/* La franja habla del marketplace (vendedores, "¿vendés autopartes?"): en una tienda propia no va. */}
                        {this.esHome() && !tiendaService.esTienda() && <FranjaConfianza/>}
                        {/* Las notificaciones push son del sitio general (Firebase registra el dominio). */}
                        {this.esHome() && !tiendaService.esTienda() && <PushOptIn/>}

                        {/*
                            Vidriera de ofertas, antes del listado.

                            Se reusa el carrusel de "relacionados" en vez de escribir uno nuevo:
                            ya pinta el badge del porcentaje y el precio tachado con las mismas
                            piezas de Oferta.js, así que el descuento se lee igual acá, en la card
                            y en la ficha.

                            Si no hay ninguna oferta corriendo la lista viene vacía y no se dibuja
                            nada — ni el título ni el espacio.
                        */}
                        {/*
                            Cartel de tienda: se entró al listado con ?vendedor=N.

                            Sin esto un catálogo filtrado por vendedor se ve exactamente igual que
                            el catálogo entero, y la persona que llegó desde "Ver todo el catálogo"
                            no tiene forma de saber que está adentro de una tienda —ni de volver a
                            la portada de esa tienda, ni de salir del filtro.
                        */}
                        {!!this.state.tienda && (
                            <div className="tienda__contexto">
                                <div className="tienda__contexto-info">
                                    <FontAwesomeIcon icon="fa-solid fa-store" size="lg"/>
                                    <div>
                                        <span className="tienda__contexto-label">Estás viendo la tienda de</span>
                                        <Link className="tienda__contexto-nombre"
                                              to={vendedorService.crearUrlTienda(this.state.tienda)}>
                                            {nombreVendedor(this.state.tienda)}
                                        </Link>
                                    </div>
                                </div>

                                <button type="button" className="button" data-type="complementary"
                                        onClick={this.salirDeTienda}>
                                    <FontAwesomeIcon icon="fa-solid fa-xmark"/>
                                    <span>Ver todo el sitio</span>
                                </button>
                            </div>
                        )}

                        {/*
                            Encabezado de pagina de categoria (/repuestos/..., /autopartes-usadas/...).
                            Es el h1 de la pagina: sin esto el listado filtrado se ve igual que
                            /busqueda y no dice de que se trata ni a la persona ni a Google.
                        */}
                        {!!categoria && (
                            <div className="categoria__contexto">
                                <div className="categoria__contexto-info">
                                    <h1 className="categoria__contexto-titulo">{categoria.h1}</h1>
                                    <p className="categoria__contexto-texto">{categoria.descripcion}</p>
                                </div>
                                {!loading && data?.results?.totalElements !== undefined && (
                                    <span className="categoria__contexto-cantidad">
                                        {data.results.totalElements === 1
                                            ? "1 publicación"
                                            : `${data.results.totalElements} publicaciones`}
                                    </span>
                                )}
                            </div>
                        )}

                        {this.state.productosEnOferta.length > 0 && (
                            <CarrouselProductosRel
                                productos={this.state.productosEnOferta}
                                nombre="Ofertas del momento"
                            />
                        )}
                        <Formik
                            enableReinitialize={true}
                            initialValues={stateValues}
                            onSubmit={(values) => {
                                this.buscarData(true, values);
                            }}
                        >
                            {({errors, touched, values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="wrapper" ref={this.listadoRef}>
                                        <div className="filter__container">
                                            {/*
                                                No hay buscador propio del listado: se busca desde el
                                                buscador del header o con los filtros de la izquierda.
                                                Lo unico que queda es el chip del texto ya aplicado,
                                                que es la unica forma de sacarselo de encima.
                                            */}
                                            {!!this.state.pagedSearch.search && (
                                                <div className="filter__busqueda">
                                                    <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                                                    <span>{this.state.pagedSearch.search}</span>
                                                    <button
                                                        type="button"
                                                        title="Quitar la búsqueda"
                                                        onClick={this.limpiarTexto}
                                                    >
                                                        <FontAwesomeIcon icon="fa-solid fa-xmark"/>
                                                    </button>
                                                </div>
                                            )}

                                            {/* Dentro de una tienda (?vendedor=N) el vendedor lo
                                                saca el cartel de la tienda, no un chip. */}
                                            <FiltrosActivos
                                                values={values}
                                                filtros={filtros}
                                                setFieldValue={setFieldValue}
                                                submitForm={submitForm}
                                                ocultar={this.state.tienda ? ["vendedor"] : []}
                                            />

                                            <div className="filterend">
                                                <div className="order_container">
                                                    <span>Ordenar por:</span>
                                                    <Select
                                                        className="filter_select"
                                                        cacheOptions
                                                        defaultOptions
                                                        placeholder="Ordenar Por"
                                                        getOptionLabel={(option) => `${option.nombre}`}
                                                        getOptionValue={(option) => option.id}
                                                        options={ordenadores}
                                                        value={ordenadores.find(
                                                            (option) => option.id === this.state.pagedSearch.orderBy.id
                                                        )}
                                                        onChange={(opt) => {
                                                            this.setOrderBy(opt);
                                                        }}
                                                        components={{
                                                            IndicatorSeparator: () => null,
                                                        }}
                                                        styles={customSelect}
                                                    />
                                                </div>
                                                <div className="view_container">
                                                    <span>Vista:</span>

                                                    <div
                                                        className={`view_icon${isGridView ? "--selected" : ""}`}
                                                        onClick={(e) => this.toggleGridView(e, "grid")}
                                                    >
                                                        <FontAwesomeIcon icon={faTh} size="lg"/>
                                                    </div>

                                                    <div
                                                        className={`view_icon${isGridView ? "" : "--selected"}`}
                                                        onClick={(e) => this.toggleGridView(e, "list")}
                                                    >
                                                        <FontAwesomeIcon icon={faList} size="lg"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {["xl"].map((expand) => (
                                            <Navbar
                                                key={expand}
                                                expand={expand}
                                                expanded={this.state.filtrosAbiertos}
                                                onToggle={(abierto) =>
                                                    this.setState({filtrosAbiertos: abierto})
                                                }
                                                className="align-items-lg-start filter__menu"
                                            >
                                                <Navbar.Offcanvas
                                                    id={`offcanvasNavbar-expand-${expand}`}
                                                    aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                                                    placement="start"
                                                >
                                                    <Offcanvas.Header closeButton>
                                                        <Offcanvas.Title
                                                            id={`offcanvasNavbarLabel-expand-${expand}`}
                                                        >
                                                            Filtros
                                                        </Offcanvas.Title>
                                                    </Offcanvas.Header>
                                                    <Offcanvas.Body>
                                                        <MenuFiltro
                                                            values={values}
                                                            filtros={filtros}
                                                            setFieldValue={setFieldValue}
                                                            submitForm={submitForm}
                                                            alAplicar={() =>
                                                                this.setState({filtrosAbiertos: false})
                                                            }
                                                        ></MenuFiltro>
                                                    </Offcanvas.Body>
                                                </Navbar.Offcanvas>
                                                <Navbar.Toggle
                                                    aria-controls={`offcanvasNavbar-expand-${expand}`}
                                                    className="button filter__toggle"
                                                    data-type="primary-small-alternative"
                                                    title="Filtros"
                                                >
                                                    <FontAwesomeIcon icon="fa-solid fa-filter"/>
                                                    <span>Filtros</span>
                                                </Navbar.Toggle>
                                            </Navbar>
                                        ))}
                                        <main className="result_container">
                                            {loading &&
                                            <LoaderGeneral grabando={loading}/>
                                            }
                                            {!loading && (
                                                <>
                                                    {items.length === 0 && (
                                                        <div className="listado__vacio">
                                                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" size="2x"/>
                                                            <p>No encontramos resultados.</p>
                                                            <span>
                                                                ¿Querés que te avisemos cuando ingrese este repuesto?
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className="button"
                                                                data-type="primary-small"
                                                                onClick={() => this.crearAlerta()}
                                                            >
                                                                <FontAwesomeIcon icon="fa-bell" color="#e6c74c"/>
                                                                Crear alerta
                                                            </button>
                                                        </div>
                                                    )}

                                                    {items.length > 0 && (
                                                        <div
                                                            className={`card__container ${
                                                                isGridView ? "grid" : ""
                                                            }`}
                                                        >
                                                            {items.map((prod) => (
                                                                <div
                                                                    key={prod.id}
                                                                    className="card__large box-shadow-1"
                                                                >
                                                                    <Link
                                                                        className='card__large-image'
                                                                        to={productoServiceTs.crearUrlProducto(prod)}
                                                                        onClick={() =>
                                                                            this.props.seleccionarProducto(prod)
                                                                        }
                                                                    >
                                                                        <div className="card__large-img">
                                                                            {/* Sobre la imagen y no junto al precio: en una
                                                                                grilla es lo unico que se ve de lejos, y es lo
                                                                                que hace frenar a quien esta escaneando. */}
                                                                            <BadgeOferta oferta={prod.oferta}/>
                                                                            <CarrouselImages
                                                                                images={this.buscarImagenes(prod)}
                                                                                esListador={true}
                                                                                esProductDetail={false}/>
                                                                        </div>
                                                                    </Link>
                                                                    <div className="card__large-content">
                                                                        <div className="card__large-content--heading">
                                                                            <Link
                                                                                to={productoServiceTs.crearUrlProducto(prod)}
                                                                                onClick={() => {
                                                                                    this.props.seleccionarProducto(prod);
                                                                                }
                                                                                }
                                                                            >
                                                                                <h3>{prod.tipoRepuesto.nombre}</h3>
                                                                            </Link>
                                                                            {/* Solo los nuevos llevan marca: hasta que hubo
                                                                                vendedores de nuevos todo el sitio era usado, y
                                                                                un "Usado" en cada card no le dice nada a nadie.
                                                                                En una tienda propia tampoco: tiene un solo rubro. */}
                                                                            {prod.condicion === "NUEVO" && !tiendaService.esTienda() && (
                                                                                <span className="card__condicion">Nuevo</span>
                                                                            )}
                                                                        </div>
                                                                        <ul>
                                                                            {/* Vehiculo y año en un solo renglon: eran dos lineas
                                                                                para seis palabras y en la vista lista cada linea
                                                                                es alto que se paga en todas las cards. */}
                                                                            <li>
                                                                                {[
                                                                                    [prod.marca.nombre, prod.modelo.nombre, prod.version?.nombre]
                                                                                        .filter(Boolean)
                                                                                        .join(" "),
                                                                                    prod.anio,
                                                                                ]
                                                                                    .filter(Boolean)
                                                                                    .join(" · ")}
                                                                            </li>
                                                                            {/*
                                                                                El Motor 04 puede traer media docena de repuestos y la
                                                                                lista completa ocupaba cuatro renglones: esa card
                                                                                quedaba al doble de alto que las de al lado por un
                                                                                dato secundario. Va en un renglon, mas chico y
                                                                                apagado, con la cuenta adelante para que se lea de
                                                                                un vistazo; el detalle entero esta en el title y en
                                                                                la ficha del producto.
                                                                            */}
                                                                            {prod.tipoRepuesto?.nombre === TIPO_REPUESTO.MOTOR_04 &&
                                                                            !!prod.motorAsociados?.length &&
                                                                            <li
                                                                                className="card__large-incluye"
                                                                                title={`Incluye: ${productoServiceTs.crearNombreMotorAsociados(prod)}`}
                                                                            >
                                                                                <strong>Incluye {prod.motorAsociados.length}:</strong>{" "}
                                                                                {productoServiceTs.crearNombreMotorAsociados(prod)}
                                                                            </li>}
                                                                        </ul>
                                                                        {/*
                                                                            Quien vende y desde donde. Estaba solo en la ficha, y es
                                                                            lo primero que se pregunta por WhatsApp; en la vista
                                                                            lista ademas ocupa el hueco que dejaba la fila ancha.
                                                                        */}
                                                                        <div className="card__large-meta">
                                                                            {nombreVendedor(prod.vendedor) && (
                                                                                <span className="card__large-meta-item">
                                                                                    <FontAwesomeIcon icon="fa-solid fa-store"/>
                                                                                    {nombreVendedor(prod.vendedor)}
                                                                                </span>
                                                                            )}
                                                                            {prod.vendedor?.provincia?.nombre && (
                                                                                <span className="card__large-meta-item">
                                                                                    <FontAwesomeIcon icon="fa-solid fa-location-dot"/>
                                                                                    {prod.vendedor.provincia.nombre}
                                                                                </span>
                                                                            )}
                                                                            {/* Positivo a proposito: con `!== SIN_ENVIO` una publicacion
                                                                                sin tipoEnvio cargado mostraba "Con envio". */}
                                                                            {prod.tipoEnvio === TIPO_ENVIO.ENVIO_A_COORDINAR &&
                                                                            productoActions.esComprable(prod) && (
                                                                                <span className="delivery">
                                                                                    <FontAwesomeIcon
                                                                                        icon="fa-solid fa-truck"/>
                                                                                    Con envio
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    <div className="card__large-actions">
                                                                        {productoActions.esComprable(prod) && (
                                                                            <div className="card__large-price">
                                                                                <PrecioTachado oferta={prod.oferta}/>
                                                                                <span className="card__large-price--currency">$
                                                                                </span>
                                                                                <div
                                                                                    className="card__large-price--money">
                                                                                    <NumberFormat
                                                                                        value={precioVigente(prod)}
                                                                                        displayType={"text"}
                                                                                        thousandSeparator="."
                                                                                        decimalSeparator=","
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/* Ocupa el lugar del precio, no el de los botones: es
                                                                            lo que se busca al escanear la grilla. */}
                                                                        {productoActions.esPrecioAConsultar(prod) && (
                                                                            <div className="card__large-price card__large-price--consultar">
                                                                                Precio a consultar
                                                                            </div>
                                                                        )}
                                                                        {/*
                                                                            Un solo boton de compra ("Comprar" duplicaba
                                                                            "Agregar al carrito" y entre los dos mas la
                                                                            consulta no entraban en mobile) y el de
                                                                            WhatsApp compacto (solo icono) al lado.
                                                                        */}
                                                                        <div className="card__large-stock">
                                                                            {productoActions.esComprable(prod) && (
                                                                                <button
                                                                                    className="button"
                                                                                    type="button"
                                                                                    data-type="accent"
                                                                                    onClick={() =>
                                                                                        cartService.agregarItem(prod)
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon="fa-solid fa-cart-shopping"/>
                                                                                    <span>Agregar</span>
                                                                                </button>
                                                                            )}

                                                                            {productoActions.esPrecioAConsultar(prod) && (
                                                                                <button
                                                                                    className="button"
                                                                                    type="button"
                                                                                    data-type="accent"
                                                                                    title="Avisame cuando entre uno de estos"
                                                                                    onClick={() => this.crearAlertaDeProducto(prod)}
                                                                                >
                                                                                    <FontAwesomeIcon icon="fa-solid fa-bell"/>
                                                                                    <span>Alerta</span>
                                                                                </button>
                                                                            )}

                                                                            {/* En la vista lista de escritorio el boton lleva la
                                                                                palabra: ahi sobra ancho y el icono solo no decia
                                                                                que hacia. En la grilla y en mobile sigue compacto,
                                                                                que es donde no entraba. */}
                                                                            {!!prod.vendedor.numeroCelular &&
                                                                                this.renderBotonConsulta(prod, isGridView || esMobile)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {!esMobile && items.length > 0 && (
                                                        <Paginador
                                                            page={data?.results?.number}
                                                            totalPages={data?.results?.totalPages}
                                                            totalElements={data?.results?.totalElements}
                                                            pageSize={this.state.pagedSearch.pageSize}
                                                            onChange={this.setNewPage}
                                                        />
                                                    )}

                                                    {/*
                                                        El pie del scroll infinito.

                                                        El botón no es un adorno ni un fallback de
                                                        lujo: sin IntersectionObserver —o con el
                                                        ahorro de datos apagando cosas— el centinela
                                                        no dispara nunca, y sin el botón el catálogo
                                                        se termina en la página 1 sin que se note.
                                                    */}
                                                    {esMobile && items.length > 0 && this.hayMasPaginas() && (
                                                        <div className="listador__mas" ref={this.observarSentinel}>
                                                            {cargandoMas ? (
                                                                <span className="listador__mas-cargando">
                                                                    <FontAwesomeIcon icon="fa-solid fa-spinner" spin/>
                                                                    Cargando más…
                                                                </span>
                                                            ) : (
                                                                <button
                                                                    className="button"
                                                                    type="button"
                                                                    data-type="primary-small-alternative"
                                                                    onClick={this.cargarMas}
                                                                >
                                                                    Ver más
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}

                                                    {/* Cierre explícito: en una lista que se carga
                                                        sola, quedarse sin scroll es ambiguo —¿se
                                                        terminó, o se colgó?—. */}
                                                    {esMobile && items.length > 0 && !this.hayMasPaginas() && (
                                                        <p className="listador__fin">
                                                            {items.length === 1
                                                                ? "1 publicación"
                                                                : `${items.length} publicaciones`}
                                                            {" · "}Llegaste al final
                                                        </p>
                                                    )}
                                                </>
                                            )}
                                        </main>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>

                <Modal size="md" show={this.state.showLogin} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Ingresá para crear tu alerta</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <LoginPage onSuccess={this.loginSuccess}></LoginPage>
                    </Modal.Body>
                </Modal>

                {this.state.showAlertModal && <Modal size="lg" show={this.state.showAlertModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Crear una alerta</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AlertaModal producto={this.state.producto} handleClose={this.handleClose}></AlertaModal>
                    </Modal.Body>
                </Modal>}

                {!!this.state.productoConsulta && (
                    <ModalWhatsappVendedor
                        show={!!this.state.productoConsulta}
                        producto={this.state.productoConsulta}
                        handleClose={() => this.setState({productoConsulta: undefined})}
                    />
                )}
            </>
        );
    }
}

function mapState(state) {
    const {option, data, filtros} = state.busqueda;
    return {option, data, filtros};
}

const actionCreators = {
    seleccionarProducto: busquedaActions.seleccionarProducto,
    traerFiltros: busquedaActions.traerFiltros,
};

const connectedListador = connect(mapState, actionCreators)(Listador);
export {connectedListador as Listador};
